import React from "react";
import { Agency } from "../messages";
import { formatPhone } from "../phone_number";
import { STRINGS } from "../strings";
import { AgencyMember } from "../system/AppState/AppAgenciesState";
import { translate } from "../translate";
import { MESSAGE_SVG } from "../utils/svgs";
import { PHONE_ICON } from "../utils/svgs_new";
import { AppButton } from "./Generic/AppButton";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import Flex from "./Generic/Flex";
import { IsDefined } from "./Generic/IsDefined";

interface Props {
  agency: Agency;
  coordinatorInCharge?: AgencyMember;
  onClickChat: () => void;
  onClickCall: () => void;
  showCallButton?: boolean;
}

export function AgencyDetailsCard(props: Props) {
  const agencyLogoUrl =
    props.agency.logoUrl !== null ? props.agency.logoUrl : "./assets/agency_logo.png";

  const coordinatorPhotoUrl =
    props.coordinatorInCharge !== undefined && props.coordinatorInCharge.details.photoUrl !== null
      ? props.coordinatorInCharge.details.photoUrl
      : "./assets/agency_logo.png";

  const coordinatorName =
    props.coordinatorInCharge !== undefined
      ? `${props.coordinatorInCharge.details.firstName} ${props.coordinatorInCharge.details.lastName}`
      : translate(STRINGS.AGENCY_COORDINATOR);

  const ivrPhoneNumbers = props.agency.ivrPhoneNumbers;

  return (
    <AppCard className="AgencyDetailsCard">
      <AppCardHeader>
        <AppCardTitle>{translate(STRINGS.AGENCY_DETAILS)}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <div>
          <Flex alignItems="center" xGap={16}>
            <div className="AgencyDetailsCard__Avatars">
              <div
                style={{ backgroundImage: `url('${agencyLogoUrl}')` }}
                className="AgencyDetailsCard__AgencyAvatar"
              />
              <div
                style={{ backgroundImage: `url('${coordinatorPhotoUrl}')` }}
                className="AgencyDetailsCard__CoordinatorAvatar"
              />
            </div>
            <div className="AgencyDetailsCard__VisitBy">
              <span className="AgencyDetailsCard__CoordinatorName">
                {translate(STRINGS.A_VISIT_BY) + " "}
                {coordinatorName}
              </span>

              <span className="AgencyDetailsCard__AgencyName">{props.agency.name}</span>

              <IsDefined value={ivrPhoneNumbers}>
                {(_ivrPhoneNumbers) => (
                  <div className="__agency-ivr">
                    IVR:{" "}
                    {_ivrPhoneNumbers.map((ivrPhone) => {
                      return (
                        <div key={ivrPhone.ivrPhoneNumber}>
                          {formatPhone(ivrPhone.ivrPhoneNumber)} {ivrPhone.description}
                        </div>
                      );
                    })}
                  </div>
                )}
              </IsDefined>
            </div>
          </Flex>
          <div className="AgencyDetailsCard__Buttons">
            <AppButton variant="filled" size="small" onClick={props.onClickChat}>
              <AppIcon icon={MESSAGE_SVG} size={16} />
              <span>{translate(STRINGS.CHAT)}</span>
            </AppButton>

            {props.showCallButton !== false && (
              <AppButton variant="outline" size="small" onClick={props.onClickCall}>
                <AppIcon icon={PHONE_ICON} size={16} />
                <span>{translate(STRINGS.CALL_AGENCY)}</span>
              </AppButton>
            )}
          </div>
        </div>
      </AppCardContent>
    </AppCard>
  );
}
